import React, { useEffect, useMemo, useState } from "react";
import { ListUserAdminPanel } from "./ListUserAdminPanel";
import { observer } from "mobx-react-lite";
import User from "../../api/User";
import { Registration } from "./Registration";
import ApiData from "../../api/ApiData";
import Loader from "../Loader";
import { BtnPrimaryv4 } from "../UI/button/BtnPrimaryv4";
import { BtnSearch } from "../tools/BtnSearch";
import { CcV4Toggle } from "../UI/CcV4Toggle";
import {
  ADMIN_USERS_SHOW_ARCHIVE_KEY,
  filterAdminUsersForPanel,
} from "../../utils/employeesSearchUtils";

export const UsersAdminPanel = observer(() => {
  const [regUser, setRegUser] = useState(false);
  const [search, setSearch] = useState("");
  const [showArchive, setShowArchive] = useState(() => {
    return localStorage.getItem(ADMIN_USERS_SHOW_ARCHIVE_KEY) === "true";
  });
  const showSuperuserCol = User.user.is_superuser;

  const startUserAdmin = async () => {
    const resUser = await ApiData.getDataEmployees();
    if (resUser) {
      User.allRole();
    }
  };

  useEffect(() => {
    startUserAdmin();
    return () => startUserAdmin;
  }, []);

  const actionSuperUser = async (e) => {
    if (e.is_superuser) {
      await User.superUser(e.id, false);
    } else {
      await User.superUser(e.id, true);
    }
  };

  const actionActiveUser = async (e) => {
    if (e.is_active) {
      User.setActiveUser(false, e.id);
    } else {
      User.setActiveUser(true, e.id);
    }
  };

  const filteredUsers = useMemo(() => {
    return filterAdminUsersForPanel(ApiData.employees, search, showArchive);
  }, [ApiData.employees, search, showArchive]);

  const onShowArchiveChange = (next) => {
    setShowArchive(next);
    localStorage.setItem(ADMIN_USERS_SHOW_ARCHIVE_KEY, String(next));
  };

  if (!ApiData.employees) {
    return <Loader />;
  }

  const gridClass = `cc-v4-soft-grid admin-users-grid${
    showSuperuserCol ? " admin-users-grid--super" : ""
  }`;

  return (
    <section className="card cc-v4-soft-list-root admin-panel-section" aria-label="Пользователи">
      <div className="admin-panel-toolbar">
        <BtnSearch
          placeholder="Поиск по фамилии, имени и должности…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="reports-search-input admin-users-search"
        />
        <CcV4Toggle
          label="В архиве"
          active={showArchive}
          onClick={() => onShowArchiveChange(!showArchive)}
        />
        {User.user.is_superuser || User.user.permission.includes("post_user") ? (
          <BtnPrimaryv4
            text="Добавить сотрудника"
            onClick={() => setRegUser(true)}
          />
        ) : null}
      </div>

      {regUser ? <Registration setRegUser={setRegUser} /> : null}

      <div className={`cc-v4-soft-header ${gridClass}`}>
        <span className="cc-v4-soft-th-static">
          <span className="cc-v4-soft-th-label">Фамилия</span>
        </span>
        <span className="cc-v4-soft-th-static">
          <span className="cc-v4-soft-th-label">Имя</span>
        </span>
        <span className="cc-v4-soft-th-static">
          <span className="cc-v4-soft-th-label">Email</span>
        </span>
        <span className="cc-v4-soft-th-static">
          <span className="cc-v4-soft-th-label">Роль</span>
        </span>
        <span className="cc-v4-soft-th-static admin-users-th-toggle">
          <span className="cc-v4-soft-th-label">Активен</span>
        </span>
        {showSuperuserCol ? (
          <span className="cc-v4-soft-th-static admin-users-th-toggle">
            <span className="cc-v4-soft-th-label">Суперюзер</span>
          </span>
        ) : null}
      </div>

      <div className="cc-v4-soft-body">
        <ListUserAdminPanel
          users={filteredUsers}
          actionSuperUser={actionSuperUser}
          actionActiveUser={actionActiveUser}
          showSuperuserCol={showSuperuserCol}
          showArchive={showArchive}
          gridClass={gridClass}
          emptySearch={search.trim().length > 0}
        />
      </div>
    </section>
  );
});
